import { render, staticRenderFns } from "./VlCard.vue?vue&type=template&id=2fd45e3d&scoped=true&"
import script from "./VlCard.vue?vue&type=script&lang=js&"
export * from "./VlCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd45e3d",
  null
  
)

export default component.exports